export default __webpack_public_path__ + "709c05f52bee27b1c6cbe0571fedfc12.svg";